import axios from 'axios';

// Optional explicit override via env
const explicitBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE;
const explicitPort = process.env.REACT_APP_API_PORT;


let baseURL = '';

if (process.env.NODE_ENV !== 'production') {
  if (explicitBase) {
    baseURL = explicitBase; // e.g., http://192.168.1.10:3001
  } else {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname)
      ? window.location.hostname
      : 'localhost';
    const port = explicitPort || '3001';
    baseURL = `http://${host}:${port}`;
  }
} else {
  // Production: ALWAYS use relative URLs to avoid mixed content
  baseURL = '';
}


// SAFETY NET: if page is HTTPS but baseURL is HTTP, force same-origin /api
if (
  typeof window !== 'undefined' &&
  window.location &&
  window.location.protocol === 'https:' &&
  /^http:\/\//i.test(baseURL)
) {
  baseURL = '/api';
}

const axiosInstance = axios.create({
  baseURL,
  // keep this as-is; prepares you for HttpOnly cookies later without changing callers
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30000,
});

// EXISTING: attach Authorization from localStorage (no change)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      // don’t clobber if caller set a custom header
      if (!config.headers?.Authorization) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// NEW: central login handling for expired/invalid sessions (401/419).
// This is the only functional addition related to login.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 419) {
      try {
        localStorage.removeItem('authToken');
      } catch (_) {}
      // Preserve current path to return after re-login
      const current =
        typeof window !== 'undefined'
          ? window.location.pathname + window.location.search
          : '/';
      const loginUrl = `/login?next=${encodeURIComponent(current)}`;
      if (typeof window !== 'undefined') {
        window.location.replace(loginUrl);
      }
    }

    // You can optionally handle 403 here (no redirect)
    return Promise.reject(error);
  }
);

export default axiosInstance;